import React, { useState, useEffect } from 'react';
import ThemeToggle from './ThemeToggle';
import { APP_VERSION } from './version';
import { checkHealth } from './api';

const defaultPrefs = {
  theme: 'light',
  dashboardStart: true,
};

function SettingsPage({ prefs, setPrefs, theme, setTheme, showToast }) {
  const [localPrefs, setLocalPrefs] = useState(prefs || defaultPrefs);
  const [backendVersion, setBackendVersion] = useState('Loading...');

  // Sync localPrefs if prefs change externally (e.g. on login)
  useEffect(() => {
    if (prefs) {
      setLocalPrefs(prefs);
    }
  }, [prefs]);

  useEffect(() => {
    checkHealth().then(res => {
      if (res.data && res.data.version) {
        setBackendVersion(res.data.version);
      } else {
        setBackendVersion('Unknown');
      }
    }).catch(() => setBackendVersion('Offline'));
  }, []);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setLocalPrefs(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme); // Apply immediately for preview
    setLocalPrefs(prev => ({ ...prev, theme: newTheme }));
  };

  const handleSave = () => {
    setPrefs(localPrefs);
    if (showToast) showToast('Settings saved!', 'success');
  };

  return (
    <div className="container" style={{ maxWidth: 600, marginTop: '2rem' }}>
      <div className="card">
        <h2 className="mt-0">Settings & Profile</h2>
        <div className="mb-4">
          <div className="mb-4">
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>Theme:</label>
            <ThemeToggle theme={localPrefs.theme || 'light'} setTheme={handleThemeChange} />
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
            <input 
              type="checkbox" 
              name="dashboardStart" 
              checked={localPrefs.dashboardStart || false} 
              onChange={handleChange} 
              style={{ width: 'auto' }}
            />
            Start on Dashboard
          </label>
        </div>
        <button onClick={handleSave} className="btn btn-primary">Save Preferences</button>
        
        <div style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid var(--border)', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
          <div>Frontend Version: {APP_VERSION}</div>
          <div>Backend Version: {backendVersion}</div>
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;

